import React, { useContext, useEffect, useState } from "react";
import Iframe from "react-iframe";
import WithLoader from "./WithLoader";

const IFrameControl1 = ({ url, setLoading }) => {
  return (
    <div className="">
      <Iframe
        url={url}
        // position="absolute"
        height="100%"
        width="100%"
        id=""
        className=""
        display="block"
        styles={{ height: "1052px", width: "725px" }}
      />
    </div>
  );
};

export default WithLoader(IFrameControl1);
